/**
 * One-off entrance animations: a script word is written out and a price sign
 * wiggles the first time it scrolls into view. Adds `is-inview` once; the
 * animations themselves are CSS.
 */
const ANIMATED = '.sda-script, .sda-sticker';

const observer = new IntersectionObserver(
  (entries) => {
    for (const { isIntersecting, target } of entries) {
      if (!isIntersecting) continue;
      target.classList.add('is-inview');
      observer.unobserve(target);
    }
  },
  { threshold: 0.6 }
);

export const observeInView = (root = document) => {
  for (const element of root.querySelectorAll(ANIMATED)) observer.observe(element);
};

observeInView();

document.addEventListener('shopify:section:load', ({ target }) => observeInView(target));
